// @flow
import {
  UPDATE_SOURCES_LOADER,
  TRIGGER_SOURCES_LOADER,
  SHOW_SOURCES_LOADER,
  HIDE_SOURCES_LOADER,
  START_HIDE_SOURCES_LOADER_TIMER,
} from './actionTypes';

export const updateSourcesLoader = ({ lastSearchUrl }: Object): TrovitAction => ({
  type: UPDATE_SOURCES_LOADER,
  payload: { lastSearchUrl },
});

export const triggerSourcesLoader = (): TrovitAction => ({
  type: TRIGGER_SOURCES_LOADER,
});

export const showSourcesLoader = (): TrovitAction => ({
  type: SHOW_SOURCES_LOADER,
});

export const hideSourcesLoader = (): TrovitAction => ({
  type: HIDE_SOURCES_LOADER,
});

export const startHideSourcesLoaderTimer = (): TrovitAction => ({
  type: START_HIDE_SOURCES_LOADER_TIMER,
});



// WEBPACK FOOTER //
// ./app/Sources/loader/actions.js